import React from "react";
import  { useEffect } from "react";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const TATTimeline = ({ tatHistory }) => {
  const calculateDurationInDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate || new Date());
    const durationInMilliseconds = end - start;
    return Math.ceil(durationInMilliseconds / (1000 * 60 * 60 * 24)); // Convert to days
  };

   useEffect(() => {
    console.log("TAT History Data:", tatHistory);
  }, [tatHistory]);


  // Calculate total TAT days from the first entry's startDate to the current date
  const totalTatDays =
    tatHistory.length > 0
      ? calculateDurationInDays(tatHistory[0].startDate, new Date())
      : 0;

  // Fixed stages for the timeline
  const stages = [
    "Requisition Approved",
    "Action on CV",
    "HR Screening/Interview",
    "Further Rounds of Interviews",
    "Candidate Final Status",
  ];

  // Helper function to determine if a stage is "Candidate Final Status"
  const isFinalStatus = (tat, index) => {
    const nextTat = tatHistory[index + 1];

    // Check if the current TAT has both startDate and endDate
    const hasStartAndEndDate = tat.startDate && tat.endDate;

    // Check if there is no next TAT
    const noNextTat = !nextTat;

    // Check if the tatStatus contains "Drop-off" or "Rejected"
    const isRejectedOrDroppedOff =
      tat.tatStatus &&
      (tat.tatStatus.toLowerCase().includes("drop-off") ||
        tat.tatStatus.toLowerCase().includes("rejected"));

    return hasStartAndEndDate && (noNextTat || isRejectedOrDroppedOff);
  };

  return (
    <div>
     

      <VerticalTimeline layout="1-column-left">
        {tatHistory.map((tat, index) => (
          <VerticalTimelineElement
            key={tat._id || index}
            date={`${new Date(tat.startDate).toLocaleDateString()} - ${
              tat.endDate ? new Date(tat.endDate).toLocaleDateString() : "Ongoing"
            }`}
            iconStyle={{ background: "#00B4D2", color: "#fff" }}
            contentStyle={{
              background: "#f9f9f9",
              color: "#333",
              padding: "10px",
              borderRadius: "8px",
            }}
            contentArrowStyle={{ borderRight: "7px solid #f9f9f9" }}
          >
            {/* Left side: Fixed stages */}
            <h3
              className="vertical-timeline-element-title"
              style={{ fontSize: "14px", marginBottom: "5px" }}
            >
              {isFinalStatus(tat, index)
                ? "Candidate Final Status"
                : stages[index] || "Unknown Stage"}
            </h3>

            {/* Right side: tatType with duration */}
            <h4
              style={{
                textAlign: "right",
                color: "#007d93",
                fontSize: "12px",
                marginBottom: "5px",
              }}
            >
              {tat.tatType} -{" "}
              {tat.endDate
                ? `${calculateDurationInDays(tat.startDate, tat.endDate)} days`
                : "Ongoing"}
            </h4>

            {/* Below: Display tatStatus */}
            <p style={{ fontSize: "12px", marginBottom: "5px" }}>
              <strong>Status:</strong> {tat.tatStatus || "Not Available"}
            </p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};

export default TATTimeline;